import { render } from "./catalog.cattle.io.clusterrepo.vue?vue&type=template&id=17139529&ts=true"
import script from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=ts"
export * from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__